var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1473 7.18105L18.5873 8.62105L13.7073 13.5011L10.4173 10.2111C10.0273 9.82105 9.39734 9.82105 9.00734 10.2111L3.00734 16.2211C2.61734 16.6111 2.61734 17.2411 3.00734 17.6311C3.39734 18.0211 4.02734 18.0211 4.41734 17.6311L9.70734 12.3311L12.9973 15.6211C13.3873 16.0111 14.0173 16.0111 14.4073 15.6211L19.9973 10.0411L21.4373 11.4811C21.7473 11.7911 22.2873 11.5711 22.2873 11.1311V6.83105C22.2973 6.55105 22.0773 6.33105 21.7973 6.33105H17.5073C17.0573 6.33105 16.8373 6.87105 17.1473 7.18105Z",
    fill: "#ff4d14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUpOutline);
export default __webpack_public_path__ + "static/media/trending_up_outline.4b2c2b2374b76b823c19efdd7de1af47.svg";
export { ForwardRef as ReactComponent };